import React from 'react';
import SingleSelect from '../../DropdownMenu/menus/SingleSelect';

export enum ProjectSortDropdownOptions {
  CreatedAtDesc = 'Newest to oldest',
  CreatedAtAsc = 'Oldest to newest',
  NameAsc = 'Name (A-Z)',
  NameDesc = 'Name (Z-A)',
}

export type ProjectSortDropdownProps = {
  value: ProjectSortDropdownOptions;
  onChange: (option: ProjectSortDropdownOptions) => void;
};

const ProjectSortDropdown = ({ value, onChange }: ProjectSortDropdownProps) => {
  const options = Object.values(ProjectSortDropdownOptions);

  return (
    <SingleSelect
      ariaLabel={'change project sort order'}
      value={value.toString()}
      items={options.map(option => ({
        value: option,
        label: option,
      }))}
      onChange={selected =>
        onChange(selected.label as ProjectSortDropdownOptions)
      }
      openLabel="Sort by"
    />
  );
};

export default ProjectSortDropdown;
